// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1bZ7A","heading":"_3MVvX","subHeading":"_26xTU"};